/**
 * T&S Ivory monogram — uses the brand SVG (placed in /public/assets/monogram.svg).
 * Used as oversized faded watermark across the experience.
 */
export default function Monogram({
  size = 500,
  opacity = 0.06,
  className = "",
  style = {},
}) {
  return (
    <img
      src="/assets/monogram.svg"
      alt=""
      aria-hidden="true"
      data-testid="ts-monogram"
      className={className}
      style={{
        width: size,
        height: size,
        opacity,
        objectFit: "contain",
        pointerEvents: "none",
        userSelect: "none",
        ...style,
      }}
    />
  );
}

/** Small inline mark for nav/footer wordmark adjacency */
export function MonogramSmall({ size = 22, className = "", style = {} }) {
  return (
    <img
      src="/assets/monogram.svg"
      alt="T&S Ivory monogram"
      data-testid="ts-monogram-small"
      className={className}
      style={{ width: size, height: size, objectFit: "contain", ...style }}
    />
  );
}
